export enum SortingOptions {
	OUR_PICKS = 'Our picks',
	UNIVERSITY_META_RANKING = 'University Meta Ranking'
}
